import { RadioGroup, Select } from '@/components'
import Card from '@/components/Form/Card'
import { clientType, stateOptions, typeOptions } from '@/components/Form/Form.data'

import { InitialFieldsProps } from './InitialFields.type'

const InitialFields = ({ formData, onChange, loading }: InitialFieldsProps) => (
  <Card>
    {/* Seleção do Tipo de Cliente */}
    <RadioGroup
      title="Selecione o Tipo:"
      options={typeOptions}
      selectedOption={formData?.Cliente_TIPO}
      name="Cliente_TIPO"
      onChange={onChange}
      disabled={loading}
    />

    {/* Caso Pessoa Jurídica: Seleção Tipo de Entidade */}
    {formData?.Cliente_TIPO === 'Pessoa Jurídica' && (
      <Select
        name="Cliente_TIPO_Entidade"
        label="Selecione o tipo de entidade"
        selectedValue={formData?.Cliente_TIPO_Entidade || ''}
        options={clientType}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        onChange={onChange}
      />
    )}

    {/* Seleção do Estado */}
    <RadioGroup
      title="Selecione o Estado:"
      options={stateOptions}
      selectedOption={formData?.Cliente_Estado}
      name="Cliente_Estado"
      onChange={onChange}
      disabled={!formData?.Cliente_TIPO || loading}
    />
  </Card>
)

export default InitialFields
